export const Organization = {
  V1: {
    AgencyAdded: 'Organization.V1.AgencyAdded',
    AgencyMoved: 'Organization.V1.AgencyMoved',
    AgencyNameChanged: 'Organization.V1.AgencyNameChanged',
    AgencyContactInfoChanged: 'Organization.V1.AgencyContactInfoChanged',
    AgencyLinkedToNewCompany: 'Organization.V1.AgencyLinkedToNewCompany',
    AgencyDeactivated: 'Organization.V1.AgencyDeactivated',
    AgencyReactivated: 'Organization.V1.AgencyReactivated',
    /** When a group has been added. */
    AgencyGroupAdded: 'Organization.V1.AgencyGroupAdded',
    /** When a group has been moved to another group. */
    AgencyGroupMoved: 'Organization.V1.AgencyGroupMoved',
    /** When a group's name and/or short name has changed. */
    AgencyGroupNameChanged: 'Organization.V1.AgencyGroupNameChanged',
    /** When a group has been removed. */
    AgencyGroupRemoved: 'Organization.V1.AgencyGroupRemoved',
    CompanyAdded: 'Organization.V1.CompanyAdded',
    CompanyDetailsChanged: 'Organization.V1.CompanyDetailsChanged',
    CompanyDeactivated: 'Organization.V1.CompanyDeactivated',
    CompanyReactivated: 'Organization.V1.CompanyReactivated'
  }
} as const

export type AgencyAddedSignalRPayload = {
  agencyId: string
  address: string | null
  countryCode: string | null
  email: string | null
  linkedCompanyCode: string | null
  mobilePhoneNumber: string | null
  name: string
  occuredAt: string
  parentGroupId: string
  phoneNumber: string | null
  shortName: string
}

export type AgencyMovedSignalRPayload = {
  agencyId: string
  name: string
  occuredAt: string
  parentGroupId: string
  shortName: string
}

export type AgencyNameChangedSignalRPayload = {
  agencyId: string
  name: string
  occuredAt: string
  shortName: string
}

export type AgencyContactInfoChangedSignalRPayload = {
  agencyId: string
  address: string | null
  countryCode: string
  email: string | null
  mobilePhoneNumber: string | null
  name: string
  occuredAt: string
  phoneNumber: string | null
  shortName: string
}

export type AgencyLinkedToNewCompanySignalRPayload = {
  agencyId: string
  address: string | null
  countryCode: string
  email: string | null
  mobilePhoneNumber: string | null
  name: string
  occuredAt: string
  phoneNumber: string | null
  shortName: string
}

export type AgencyDeactivatedSignalRPayload = {
  agencyId: string
  address: string | null
  countryCode: string
  email: string | null
  mobilePhoneNumber: string | null
  name: string
  occuredAt: string
  phoneNumber: string | null
  shortName: string
}

export type AgencyReactivatedSignalRPayload = {
  agencyId: string
  address: string | null
  countryCode: string
  email: string | null
  mobilePhoneNumber: string | null
  name: string
  occuredAt: string
  phoneNumber: string | null
  shortName: string
}

export type AgencyGroupAddedSignalRPayload = {
  agencyGroupId: string
  name: string
  occuredAt: string
  parentGroupId: string
  shortName: string
}

export type AgencyGroupMovedSignalRPayload = {
  agencyGroupId: string
  name: string
  occuredAt: string
  parentGroupId: string
  shortName: string
}

export type AgencyGroupNameChangedSignalRPayload = {
  agencyGroupId: string
  name: string
  occuredAt: string
  parentGroupId: string
  shortName: string
}

export type AgencyGroupDeactivatedSignalRPayload = {
  agencyGroupId: string
  name: string
  occuredAt: string
  parentGroupId: string
  shortName: string
}

export type CompanyAddedSignalRPayload = {
  code: string
  description: string | null
  name: string
  occurredAt: string
}

export type CompanyDetailsChangedSignalRPayload = {
  code: string
  description: string | null
  name: string
  occurredAt: string
}

export type CompanyDeactivatedSignalRPayload = {
  code: string
  name: string
  occurredAt: string
}

export type CompanyReactivatedSignalRPayload = {
  code: string
  name: string
  occurredAt: string
}
